import { render, staticRenderFns } from "./DatasetProperties.vue?vue&type=template&id=7f802c10&scoped=true&"
import script from "./DatasetProperties.vue?vue&type=script&lang=js&"
export * from "./DatasetProperties.vue?vue&type=script&lang=js&"
import style0 from "./DatasetProperties.vue?vue&type=style&index=0&id=7f802c10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f802c10",
  null
  
)

export default component.exports